import { z } from "zod";

const schema = z.object({
  biography: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateBiographyFormSchema,
  type Schema as CandidateBiographyFormSchema,
};
